import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    payment_methods: [],
    payment_method: {},
    new_payment_method: {},
  },
  actions,
  mutations,
  getters,
};
